module.exports = __webpack_public_path__ + "img/img-726619.png";